import { DataSyncStatusSchema, PersonioCredentialsSchema } from '../../shared/data-sync';
export const linkPersonioContract = {
    method: 'POST',
    path: '/api/v2/data-sync/personio',
    description: 'Link Personio as the data source with API credentials',
    requestSchema: PersonioCredentialsSchema,
    responseSchema: DataSyncStatusSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Bad Request - Personio rejected the credentials',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - not allowed to manage the data source',
            409: 'Conflict - a sync run is reading or applying, or Personio could not be read'
        }
    }
};

//# sourceMappingURL=link-personio.contract.js.map